export default {
  UNEXPECTED_ERROR_OCCURRED: 'UNEXPECTED_ERROR_OCCURRED',
  INVALID_DATA: 'INVALID_DATA',
};
